import React, { FC } from 'react';
import styles from './loaderComponent.module.css';

export const LoaderComponent: FC = () => <div className={styles.loader} />;
